import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import { bindAll } from '@bibliocommons/utils-react';

import { trackHoldingsConsumeAccess } from 'app/actions/AnalyticsGa4Actions';
import { selectOnlineResourcesForCurrentBib } from 'app/selectors/bibs/EvaluationSelector';
import { onlineResourceShape } from 'app/shapes/bibPage';
import OnlineResources from './OnlineResources';

export class OnlineResourcesContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleClick({ title, uri }) {
    const metadata = {
      metadata_category_type: 'holdings_electronic_resource_related',
      metadata_value: uri
    };
    const ui = {
      ui_container_type: 'section',
      ui_container_title: 'online-resources',
      ui_component_type: 'link-text',
      ui_component_label: title
    };

    this.props.trackHoldingsConsumeAccess({ bibId: this.props.metadataId, metadata, ui });
  }

  render() {
    return <OnlineResources handleClick={this.handleClick} onlineResources={this.props.onlineResources} />;
  }
}

OnlineResourcesContainer.propTypes = {
  metadataId: PropTypes.string,
  onlineResources: ImmutablePropTypes.listOf(onlineResourceShape).isRequired,
  trackHoldingsConsumeAccess: PropTypes.func
};

const mapStateToProps = state => ({
  onlineResources: selectOnlineResourcesForCurrentBib(state)
});

const mapDispatchToProps = dispatch => ({
  trackHoldingsConsumeAccess: bindActionCreators(trackHoldingsConsumeAccess, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(OnlineResourcesContainer);
